import { render, staticRenderFns } from "./NotificationPermissionModal.vue?vue&type=template&id=418c452e&scoped=true"
import script from "./NotificationPermissionModal.vue?vue&type=script&lang=ts"
export * from "./NotificationPermissionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c452e",
  null
  
)

export default component.exports